

// const RegistroDocumentoModal = ({ onSave, onClose, data: visitas }) => {

import { Switch } from "@headlessui/react"
import { Button, Input } from "../../components/Form"
import { useEffect, useState } from "react";
import TwoColumRow from "../../components/TwoColumRow";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { agruparLaboratorios, createAgrupacionLaboratorios, createGrupoLaboratorio, getGruposLaboratorios } from "../../redux/features/gruposLaboratoriosSlice";
import { getLaboratorios } from "../../redux/features/laboratorios2Slice";

export const NuevoGrupoLaboratorio = ({ onsave, onclose }) => {

  const [grupoNombre, setGrupoNombre] = useState("");

  const [values, setValues] = useState(
    // laboratorios.reduce((acc, item) => {
    //   acc[item.id] = false;
    //   return acc;
    // }, {})
    {}
  );

  const dispatch = useDispatch();

  const {
    data: gruposLaboratorios,
    isLoading: loadingGrupoLAboratorios,
    error: errorGrupoLAboratorios
  } = useSelector(state => state.gruposLaboratorios);

  const {
    data: laboratorios,
    isLoading: loadingLaboratorios,
    error: errorLaboratorios
  } = useSelector(state => state.laboratorios2)

  const {
    agrupaciones,
    isLoading: loadingAgrupaciones,
    error: errorAgrupaciones
  } = useSelector(state => state.gruposLaboratorios);

  useEffect(() => {
    dispatch(getLaboratorios());
    dispatch(getGruposLaboratorios());
    dispatch(agruparLaboratorios());
  }, [dispatch]);

  useEffect(() => {
    if (laboratorios?.length > 0) {
      const valoresIniciales = laboratorios.reduce((acc, item) => {
        acc[item.id] = false;
        return acc;
      }, {});
      setValues(valoresIniciales);
    }
  }, [laboratorios]);



  const handleSubmit = () => {

    toast('Inicio el proceso de guardado', {
      icon: '⚠️',
      style: {
        background: '#fff3cd',  // Fondo amarillo suave
        color: '#856404',       // Texto marrón oscuro
        border: '1px solid #ffeeba',
      },
    });


    const seleccionados = Object.entries(values)
      .filter(([key, value]) => value)
      .map(([key]) => key);

    const datosAGuardar = {
      nombreGrupo: grupoNombre,
      laboratoriosSeleccionados: seleccionados,
    };

    if (datosAGuardar.laboratoriosSeleccionados.length === 0) {
      toast.error("Debe seleccionar al menos un laboratorio");
      return;
    }

    if (!datosAGuardar.nombreGrupo) {
      toast.error("Debe ingresar un nombre para el grupo");
      return;
    }

    // console.log(datosAGuardar)

    // onsave(datosAGuardar); // Aquí puedes enviar los datos seleccionados al padre o manejarlos como necesites
    registroNuevoGrupo(datosAGuardar)

    // onclose();
  };

  const registroNuevaAgrupacion = async (data, grupo_id) => {
    const newIdAg = agrupaciones.reduce((max, grupo) =>
      grupo.id > max ? grupo.id : max,
      0 // o -Infinity si los ids pueden ser negativos
    );
    const valoresConvertidos = data.map(Number);
    // Enviar cada agrupación individualmente
    for (let i = 0; i < valoresConvertidos.length; i++) {
      const nuevaAgrupacion = {
        id: newIdAg + i + 1,
        grupos_laboratorios_id: grupo_id,
        laboratorios2_id: valoresConvertidos[i],
      };
      console.log(nuevaAgrupacion)
      try {
        await dispatch(createAgrupacionLaboratorios(nuevaAgrupacion)).unwrap();
        // dispatch(getGruposLaboratorios()); // Opcional: recarga la lista actualizada
        // dispatch(agruparLaboratorios())
        // toast.success(`Agrupacion ${i + 1} creada`);
      } catch (error) {
        console.error("Error al crear el grupo:", error);
        toast.error(
          `Error la agrupacion: ${error.message || JSON.stringify(error)}`
        );
      }
    }
    dispatch(agruparLaboratorios())
    dispatch(getGruposLaboratorios());
    toast.success("Agrupacion creada con éxito");
    onclose();
  }

  const registroNuevoGrupo = async (data) => {
    const newId = gruposLaboratorios.reduce((max, grupo) =>
      grupo.id > max ? grupo.id : max,
      0 // o -Infinity si los ids pueden ser negativos
    );
    const nuevoGrupo = {
      id: (newId + 1),
      nombre: data.nombreGrupo
    }
    try {
      await dispatch(createGrupoLaboratorio(nuevoGrupo)).unwrap();
      toast.success("Grupo creado con éxito");
      // dispatch(getGruposLaboratorios()); // Opcional: recarga la lista actualizada
      registroNuevaAgrupacion(data.laboratoriosSeleccionados, (newId + 1))
    } catch (error) {
      console.error("Error al crear el grupo:", error);
      toast.error(
        `Error al guardar el grupo: ${error.message || JSON.stringify(error)}`
      );
    }
  }


  return (
    <>
      <Input
        label="Nombre del Nuevo Grupo"
        placeholder="Nombre del nuevo grupo"
        color={true}
        value={grupoNombre}
        // Aunque no uses `register`, puedes manejar el cambio así:
        register={{
          onChange: e => setGrupoNombre(e.target.value),
        }}
      />
      <div className="mt-5 text-black text-sm" >Laboratorios</div>
      <div className="max-h-[40vh] overflow-y-auto">

        {
          laboratorios.map((item, index) => (

            // <div key={index} className="flex">
            <div key={index} className="flex items-start py-2">
              <div className="flex-shrink-0 h-10 flex items-center">

                <Switch
                  checked={!!values[item.id]}
                  onChange={() =>
                    setValues(prev => ({
                      ...prev,
                      [item.id]: !prev[item.id]
                    }))
                  }
                  className={`${values[item.id] ? "bg-subMain" : "bg-border"
                    } relative inline-flex p-[2px] w-12 cursor-pointer rounded-full transitions flex-shrink-0`}
                >
                  <span
                    aria-hidden="true"
                    className={`${values[item.id] ? "translate-x-5" : "translate-x-0"
                      } pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg transitions`}
                  />
                </Switch>
              </div>

              <label className="ml-5">{item.nombre.toUpperCase()}</label>
            </div>
          ))
        }
      </div>
      <TwoColumRow className='mt-5'>
        <Button
          label={"Cancelar"}
          onClick={onclose}
        />
        <Button
          label={`Guardar Grupo`}
          onClick={handleSubmit}
        />
      </TwoColumRow >
      {/* <div>Grupo de Laboratorios</div>
      {gruposLaboratorios.map((item, index) => (
        <div>{item.nombre}</div>
      ))} */}
    </>

  )
}
